export default __webpack_public_path__ + "static/media/330_dummy2016-sprachunterricht01-de.91efe28c.png";